import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';

export type ProfileChangePasswordFormFields = {
    action: 'Change Password';
    currentPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
};

export type ProfileChangePasswordSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type ProfileChangePasswordErrorResponse = Api.Response.Failure<
    keyof ProfileChangePasswordFormFields
>;

export const usePostProfileChangePassword = (): UseMutationResult<
    ProfileChangePasswordSuccessResponse,
    ProfileChangePasswordErrorResponse,
    ProfileChangePasswordFormFields
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData,
            locale,
            method: 'POST',
            uri: '/ui/profile/change-password/',
        }),
    );
};
